import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { provideHttpClient } from "@angular/common/http";
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from "@angular/core";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { httpInterceptorProviders } from "@core";
import { APP_ROUTE } from "./features/app.routes";

import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideEffects } from "@ngrx/effects";
import { provideState, provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import * as storeDetailsEffect from "@shared/store/store-details/effects";

import { NgProgressHttpModule } from "ngx-progressbar/http";
import { NgProgressRouterModule } from "ngx-progressbar/router";
import { ToastrModule } from "ngx-toastr";
import * as authLoginEffect from "./features/sessions/login/store/effects";
import * as registrationEffects from "./features/sessions/register/store/effects";
import {
  registrationFeatureKey,
  registrationReducer,
} from "./features/sessions/register/store/reducer";
import {
  loginFeatureKey,
  loginReducer,
} from "./features/sessions/login/store/reducers";
import {
  metacomFeatureKey,
  metacomReducer,
} from "@shared/store/metacom/reducers";
import * as metacomEffect from "@shared/store/metacom/effects";
import {
  storeFeatureKey,
  storeReducer,
} from "@shared/store/store-details/reducers";
import { MatSelectCountryModule } from "@angular-material-extensions/select-country";
import {
  forgotPasswordFeatureKey,
  forgotPasswordReducer,
} from "./features/sessions/forgot-password/store/reducer";

import * as forgotPasswordEffects from "./features/sessions/forgot-password/store/effects";

import { MatSnackBarModule } from "@angular/material/snack-bar";

import * as passwordPolicyEffect from "@shared/components/password-policy/store/effects";
import {
  passwordPolicyFeatureKey,
  passwordPolicyReducer,
} from "@shared/components/password-policy/store/reducers";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideRouter(APP_ROUTE),
    provideAnimations(),
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    httpInterceptorProviders,
    importProvidersFrom(NgProgressHttpModule, NgProgressRouterModule),
    provideStore(),
    provideState(loginFeatureKey, loginReducer),
    provideState(metacomFeatureKey, metacomReducer),
    provideState(storeFeatureKey, storeReducer),
    provideState(registrationFeatureKey, registrationReducer),
    provideState(forgotPasswordFeatureKey, forgotPasswordReducer),
    provideState(passwordPolicyFeatureKey, passwordPolicyReducer),
    provideEffects(storeDetailsEffect),
    provideEffects(authLoginEffect),
    provideEffects(registrationEffects),
    provideEffects(metacomEffect),
    provideEffects(forgotPasswordEffects),
    provideEffects(passwordPolicyEffect),

    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      trace: false,
      traceLimit: 75,
    }),

    { provide: MAT_DATE_LOCALE, useValue: "en-ZA" },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: "YYYY-MM-DD",
        },
        display: {
          dateInput: "YYYY-MM-DD",
          monthYearLabel: "YYYY MMM",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "YYYY MMM",
        },
      },
    },
    importProvidersFrom(MatSelectCountryModule.forRoot("en")),

    importProvidersFrom(ToastrModule.forRoot()),
    importProvidersFrom(MatSnackBarModule),
    provideAnimationsAsync(),
  ],
};
